<template>
    <ModalConfirm
        id="modal-confirm-yakin-benar-kas-kecil"
        title="Konfirmasi Yakin Benar"
        desc="Apakah Anda yakin data kas kecil ini sudah benar?"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-yakin-benar",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
